import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import { getPageProps } from "@services/initial-calls";
import TermsAndConditions from "@components/shared/legal/termsAndConditions";
import dynamic from "next/dynamic";
const LejeuneCampLejeuneWrapper = dynamic(
    () => import("@components/layouts/basecamplejeuneWrapper"),
);
export default function CampLejeuneApplicationHome(): ReactElement {
    return (
        <LejeuneCampLejeuneWrapper>
            <div className="w-full max-w-7xl mx-auto">
                <TermsAndConditions
                    category="Camp Lejeune"
                    domain="BaseCampLejeune.com.com"
                />
            </div>
        </LejeuneCampLejeuneWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
